import { useState } from 'react'

import { Loader2 } from 'lucide-react'

import InfoIcon from '@src/components/icons/Info'
import { formatExchangePrice } from '@src/utils/formatExchangePrice'

import { PriceInfoProps } from './types'

export function PriceInfo({
    isPriceFlipped,
    setIsPriceFlipped,
    sellData,
    buyData,
    isWrapOrUnwrapOnly,
    isBuyOutputLoading,
    isQuoteLoading,
}: PriceInfoProps) {
    const [showPriceTooltip, setShowPriceTooltip] = useState(false)

    // Create price string variables
    const regularPriceString = isWrapOrUnwrapOnly
        ? '1:1'
        : `1 ${sellData.token?.symbol} = ${formatExchangePrice(sellData, buyData)} ${buyData.token?.symbol}`
    const flippedPriceString = isWrapOrUnwrapOnly
        ? '1:1'
        : `1 ${buyData.token?.symbol} = ${formatExchangePrice(buyData, sellData)} ${sellData.token?.symbol}`

    const priceString = isPriceFlipped ? flippedPriceString : regularPriceString

    return (
        <div className='relative flex flex-row'>
            <button className='flex cursor-pointer items-center rounded-lg bg-mach-gray px-2 py-1 text-sm text-white transition-colors duration-300 hover:opacity-80'>
                {isBuyOutputLoading || isQuoteLoading ? (
                    <div className='flex min-h-[20px] items-center gap-[6px]'>
                        <Loader2 className='text-mach-mach-green h-3 w-3 animate-spin' />
                        <span className='max-w-[150px] truncate text-sm leading-5 md:max-w-none md:overflow-visible'>
                            Loading best price
                        </span>
                    </div>
                ) : (
                    <div
                        onClick={() => {
                            if (!isWrapOrUnwrapOnly) {
                                setIsPriceFlipped(!isPriceFlipped)
                            }
                        }}
                        className={
                            isWrapOrUnwrapOnly
                                ? 'min-h-[20px] max-w-[150px] cursor-default truncate text-sm leading-5 md:max-w-none md:overflow-visible'
                                : 'min-h-[20px] max-w-[150px] cursor-pointer truncate text-sm leading-5 md:max-w-none md:overflow-visible'
                        }
                    >
                        {priceString}
                    </div>
                )}

                {isWrapOrUnwrapOnly && (
                    <div
                        className='ml-2 inline-block cursor-pointer align-middle'
                        onMouseEnter={() => setShowPriceTooltip(true)}
                        onMouseLeave={() => setShowPriceTooltip(false)}
                    >
                        <InfoIcon className='h-4 w-4 text-mach-sub-text' />
                    </div>
                )}

                {showPriceTooltip && (
                    <div className='absolute bottom-full left-0 mb-2 w-48 rounded-md bg-mach-modal-background p-2 text-xs text-white shadow-lg'>
                        Testnet prices are hardcoded and may adjust in the future.
                    </div>
                )}
            </button>
        </div>
    )
}
